module.exports = __webpack_public_path__ + "media/images/close-black-f7450c7ed06ae1d7d0573076d3cdb505.svg";